import React from 'react'

const TooltipTemplateMultipleItems = ({msg}) => {
  return (
    <span>{msg}</span>
  )
}

export default TooltipTemplateMultipleItems